<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<span class="int_type mgr_15">
						<select v-model="active_yn" class="tbl_select sm_int">
							<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
						</select>
					</span>
					<span class="mgr_10">
						<item-class-group v-model.trim="group_code" :headers="headers" />
					</span>
					<span class="int_type_no_border">
						<label class="mgr_5">
							<input type="radio" v-model="comparison_target" value="ship_to_code" />
							<em class="lt_text">Ship to</em>
						</label>
						<label class="mgr_5">
							<input type="radio" v-model="comparison_target" value="bill_to_code" />
							<em class="lt_text">Bill to</em>
						</label>
					</span>
					<span class="int_type_no_border">
						<em class="lt_text">Customer</em>
						<PartnerSelect :restrictionOnly="restriction_only" v-model="partner_code" :ph="comparison_target === 'ship_to_code' ? 'Ship to' : 'Bill to'" :showName="false" @set-partner="partner => (partner_code = partner.code)" />
					</span>
				</p>
				<p class="mgb_5">
					<span class="int_type_no_border mgr_5">
						<item-class-select-multi-s :key="item_class_component_key" :multiSelect="true" :syncWithString="true" :hideClassesString="true" v-model="item_classes_string" />
					</span>
					<span class="int_type_no_border mgr_5">
						<ItemClassKeywordSearch @setClassList="addSearchingItemClasses" :customPlaceholder="`Search by Item ${headers.class} Code Starting with Keyword`" />
					</span>
					<span class="int_type_no_border mgl_15">
						<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
						<a href="javascript:void(0);" class="gray_bt mgr_5" @click="reset()">Reset</a>
					</span>
				</p>
				<p class="mgb_5">
					<em class="lt_text">Selected Item {{ headers.class }}</em>
					<textarea rows="3" v-model.trim="item_classes_string" class="textarea_type" style="display:inline-block; vertical-align:middle; width: 70%;" @focus="$event.target.select()" @input="item_class_component_key++" />
				</p>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<CommonTable :tbl_headers="tbl_headers" :data="root_list" @onOrderClick="onOrderClick" @onPendingClick="onPendingClick" />
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'POStatus'" :draggable="false" @keydown.esc.prevent="test()">
			<template slot="title">PO Status</template>
			<template slot="body">
				<POStatusPopup :item_id="item_id" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'PreemtedSO'" :draggable="false">
			<template slot="title">Preempted SO(s)</template>
			<template slot="body">
				<PreemptedSoPopup :item_id="selectedItemId" :pending_90="pending_90" v-on:close="closeModal()" />
			</template>
		</Modal>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassGroup from '@/components/common/ItemClassGroup';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import ItemClassKeywordSearch from '@/components/common/ItemClassKeywordSearch';
import Modal from '@/components/common/Modal';
import POStatusPopup from '@/components/common/POStatusPopup';
import PreemptedSoPopup from '@/components/common/PreemptedSoPopup';

import { apiItemInquiryByPartner } from '@/api/report/report.js';
import { defaultDataType } from 'export-xlsx';
import { exportDataExcel } from '@/api/util';
export default {
	mixins: [stateReport({ id: 'ItemInquiry', search: 'selectData', queries: ['selectData'], results: ['root_list'] })],
	data: () => ({
		active_yn: 'Y',
		comparison_target: 'ship_to_code',
		partner_code: '',
		item_classes_string: '',
		separator: ',',
		item_class_component_key: 0,
		group_code: '',

		root_list: [],
		tbl_headers: [],

		showModal: false,
		modalName: null,
		item_id: null,
	}),
	components: {
		CommonTable,
		PartnerSelect,
		ItemClassGroup,
		ItemClassSelectMultiS,
		ItemClassKeywordSearch,
		Modal,
		POStatusPopup,
		PreemptedSoPopup,
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		itemClasses() {
			let res = [];

			if (this.item_classes_string) {
				this.item_classes_string.split(this.separator).forEach(el => {
					if (!res.some(e => e === el)) res.push(el);
				});
			}

			return res;
		},
		isNewjigu() {
			return this.$session.get('company').company_id === 'newjigu';
		},
	},
	methods: {
		onOrderClick(item) {
			if (this.state_report_locked) return;
			// let routeData = this.$router.resolve({ name: 'onOrderDetail', query: this.stateReportQuery({ backUri: this.uri, class_code: item.class_code }) });
			// window.open(routeData.href, 'herp_on_order_detail');
			this.item_id = item.item_id;
			this.modalName = 'POStatus';
			this.showModal = true;
		},
		onPendingClick(item) {
			if (this.state_report_locked) return;
			if (this.user.preempted_so_view) {
				this.selectedItemId = item.item_id;
				this.pending_90 = true;
				this.modalName = 'PreemtedSO';
				this.showModal = true;
			}
		},
		closeModal() {
			this.showModal = false;
		},
		addSearchingItemClasses(itemClassList) {
			if (!itemClassList || !itemClassList.length) return;
			this.item_classes_string = itemClassList.map(cls => cls.code).join(this.separator);
			this.item_class_component_key++;

			this.selectData();
		},
		reset() {
			this.comparison_target = 'ship_to_code';
			this.partner_code = '';
			this.item_classes_string = '';
			this.item_class_component_key++;
		},
		async selectData() {
			if (!this.partner_code) return this.$toast.error('Please, Select Customer.');
			if (!this.itemClasses.length && !this.group_code) return this.$toast.error('Please, Select Item ' + this.headers.class + ' Or ' + this.headers.class + ' Group.');

			//console.log(this.active_yn);
			const { data } = await apiItemInquiryByPartner.call(this, this.comparison_target, this.partner_code, this.itemClasses, this.group_code || '', this.active_yn);
			// console.log(JSON.stringify(data, null, 4));
			if (Array.isArray(data)) {
				data.forEach(el => {
					el.s_avg = el.s_365 ? el.s_365 / 12 : null;
					if (el.inv_bo_processed_yn === 'N' && el.inv_bo_quantity > 0 && 1 > el.pre_order) {
						if (el.pre_order === 0 && (el.ord_invoice_no || 0) > (el.inv_invoice_no || 0)) {
							el.display_order_date = el.ord_so_date;
							el.display_order_qty = el.ord_quantity;
						} else {
							el.display_order_date = el.inv_invoice_date;
							el.display_order_qty = el.inv_bo_quantity;
						}
					} else {
						el.display_order_date = el.ord_so_date;
						el.display_order_qty = el.ord_quantity;
					}

					el.cell_style = { available_quantity: [el.available_quantity > 0 ? 'blue_letter' : 'red_letter', 'bold_letter'] };
				});

				this.root_list = data;
			} else {
				this.root_list = [];
			}
		},
		defaultHeader() {
			return [
				{ key: 'item_code', name: 'Item', width: 20, dataType: defaultDataType.string, td_class: 'al_center' },
				{ key: 'inv_invoice_date', name: 'Last D.', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'inv_shipped_quantity', name: 'Qty.', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'inv_unit_price', name: 'Price', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 's_avg', name: 'M.AVG', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 's_30', name: 'S30', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 's_60', name: 'S60', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 's_90', name: 'S90', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 's_365', name: 'S365', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'display_order_date', name: 'Order D.', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'display_order_qty', name: 'Qty.', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'a_price', name: 'Price A', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'b_price', name: 'Price B', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'c_price', name: 'Price C', width: 10, dataType: defaultDataType.number, tbl_width: '4%', td_class: 'al_right', display_filter: 'toCurrency' },
				{ key: 'on_hand', name: 'On Hand', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'available_quantity', name: 'Available', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'received_date', name: 'Rcvd. D.', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'received_quantity', name: 'Qty.', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'po_date', name: 'P/O D.', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
				{ key: 'po_quantity', name: 'Qty.', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'on_board_quantity', name: 'On Board', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'arrival_date', name: 'Arr D.', width: 10, dataType: defaultDataType.string, tbl_width: '4%', td_class: 'al_center' },
			];
		},
		newjiguHeader() {
			const headers = this.defaultHeader();
			const added_headers = [
				{ key: 'pending_30_quantity', name: 'P.30', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'pending_90_quantity', name: 'P.90', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated', click_event: 'onPendingClick' },
				{ key: 'avg_3ms_quantity', name: '3M AVG', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'po_on_order_quantity', name: 'On Order', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', click_event: 'onOrderClick', display_filter: 'commaSeparated' },
			];

			let idx = headers.findIndex(el => el.key === 'received_date');
			if (idx < 0) idx = headers.length;

			headers.splice(idx, 0, ...added_headers);
			return headers;
		},
		setHeaders() {
			if (this.isNewjigu) this.tbl_headers = this.newjiguHeader();
			else this.tbl_headers = this.defaultHeader();
		},
		excel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (!state_output.valid) return;
			exportDataExcel(this.root_list, this.tbl_headers, 'Item_Inquiry');
		},
	},
	created() {
		if (this.$route.query.comparison_target) this.comparison_target = this.$route.query.comparison_target;
		if (this.$route.query.partner_code) this.partner_code = this.$route.query.partner_code;
		if (this.$route.query.class_code) this.item_classes_string = this.$route.query.class_code;

		this.setHeaders();
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_item_inquiry');
		this.$store.commit('setSubTitle', 'Report -> Item Inquiry');

		if (this.$route.query.partner_code && this.$route.query.class_code) this.selectData();
	},
};
</script>

<style></style>
